import { Table } from "common";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import FormHandler from "../common/formHandler/FormHandler";
import {
  useGetConsultantImpactsQuery,
  useDeleteImpactMutation,
  useGetAccountImpactsQuery,
} from "features/impacts/impactsSlice";
import { store } from "app/store";
import { createColumnHelper } from "@tanstack/react-table";
import { useGetUserListQuery } from "features/user/userSlice";
import { toast } from "react-toastify";

function Impacts() {
  let userList = [];
  let impactListByConsultant = [];
  let impactListByAccount = [];
  let consultantId;
  let accountId;
  const [model, setModel] = useState(false);
  const [impactId, setImpactId] = useState();
  const [deleteImpactName, setDeleteImpactName] = useState("");
  const [viewAll, setviewAll] = useState("MINE");
  const DELETE_DIALOG_TITLE = "Impact: Delete";
  const DELETE_DIALOG_MESSAGE = `Are you sure you want to delete "${deleteImpactName}" impact?`;

  if (store.getState().auth.userData)
    consultantId = store.getState().auth.userData.id;
  if (store.getState().auth.userData === null) accountId = 0;
  else accountId = store.getState().auth.userData.organization;

  const {
    data: impactByConsultantInfo,
    isSuccess: isImpactByConsultantSuccess,
  } = useGetConsultantImpactsQuery(consultantId, {
    refetchOnMountOrArgChange: true,
  });

  if (isImpactByConsultantSuccess) {
    impactListByConsultant = impactByConsultantInfo.data;
  }
  const { data: impactByAccountInfo, isSuccess: isImpactByAccountSuccess } =
    useGetAccountImpactsQuery(accountId, {
      refetchOnMountOrArgChange: true,
    });
  if (isImpactByAccountSuccess) {
    impactListByAccount = impactByAccountInfo.data;
  }

  const [deleteImpact] = useDeleteImpactMutation();

  const handleUserList = useGetUserListQuery({
    refetchOnMountOrArgChange: true,
  });

  if (handleUserList.isSuccess === true) {
    userList = handleUserList.data.data;
  }

  const deleteDialog = (impactId, impactName) => {
    setImpactId(impactId);
    setDeleteImpactName(impactName);
    return setModel(true);
  };

  const hideDialog = () => {
    setModel(false);
  };

  const deleteHandle = async () => {
    if (impactId) {
      const deleted = await deleteImpact(impactId);
      if (deleted?.data?.status === "success")
        toast.success("Deleted successfully.");
      setImpactId(null);
      setDeleteImpactName("");
    }

    setModel(false);
  };

  const formatOwnerConsultant = (id) => {
    if (id) {
      const consultant = userList.find((user) => user.id === id);
      return consultant
        ? `${consultant.first_name} ${consultant.last_name}`
        : "";
    }
    return "";
  };

  let defaultData = [];

  if (viewAll === "ALL") {
    defaultData = impactListByAccount || [];
  }
  if (viewAll === "MINE") {
    defaultData = impactListByConsultant || [];
  }
  const columnHelper = createColumnHelper();

  const columnsAll = [
    columnHelper.accessor((row) => row.title, {
      id: "title",
      cell: (info) => (
        <Link to={`/impacts/${info.row.original.id}`}>{info.getValue()}</Link>
      ),
      header: () => <span>Title</span>,
    }),
    columnHelper.accessor((row) => row.stage, {
      id: "stage",
      cell: (info) => (
        <>
          {info.row.original.stage === "Not-Started" ? (
            <span className='badge text-bg-danger'>
              {info.row.original.stage}
            </span>
          ) : info.row.original.stage === "In-Progress" ? (
            <span className='badge text-bg-warning'>
              {info.row.original.stage}
            </span>
          ) : (
            <span className='badge text-bg-success'>
              {info.row.original.stage}
            </span>
          )}
        </>
      ),
      header: () => <span>Stage</span>,
    }),
    // columnHelper.accessor((row) => row.overall_target_value, {
    //   id: "overall_target_value",
    //   cell: (info) => info.getValue(),
    //   header: () => <span>Overall Target Value</span>,
    // }),
    columnHelper.accessor((row) => row.owner_consultant, {
      id: "owner_consultant",
      cell: (info) => formatOwnerConsultant(info.getValue()),
      header: () => <span>Owner Consultant</span>,
      show: viewAll === "ALL",
    }),

    columnHelper.accessor((row) => row.goal_title, {
      id: "goal_title",
      cell: (info) => (
        <Link
          to={`/goals/${info.row.original.goal}`}
          state={{ goalId: info.row.original.goal }}
          style={{ textDecoration: "none" }}
        >
          {info.getValue()}
        </Link>
      ),
      header: () => <span>Belongs To</span>,
    }),

    {
      id: "actions",
      cell: (info) => (
        <div>
          <span className='action-item'>
            <FormHandler
              formInputs={{
                formType: "Impact",
                formAction: "Edit",
                itemDetails: {
                  id: info.row.original.id,
                },
              }}
            />
          </span>
          <span className='action-item'>
            <i
              className='bi bi-trash-fill'
              data-bs-placment='center'
              title='Delete'
              onClick={() =>
                deleteDialog(info.row.original.id, info.row.original.title)
              }
            ></i>
          </span>
        </div>
      ),
    },
  ];

  const columnsMine = [
    columnHelper.accessor((row) => row.title, {
      id: "title",
      cell: (info) => (
        <Link to={`/impacts/${info.row.original.id}`}>{info.getValue()}</Link>
      ),
      header: () => <span>Title</span>,
    }),
    columnHelper.accessor((row) => row.stage, {
      id: "stage",
      cell: (info) => (
        <>
          {info.row.original.stage === "Not-Started" ? (
            <span className='badge text-bg-danger'>
              {info.row.original.stage}
            </span>
          ) : info.row.original.stage === "In-Progress" ? (
            <span className='badge text-bg-warning'>
              {info.row.original.stage}
            </span>
          ) : (
            <span className='badge text-bg-success'>
              {info.row.original.stage}
            </span>
          )}
        </>
      ),
      header: () => <span>Stage</span>,
    }),
    // columnHelper.accessor((row) => row.overall_target_value, {
    //   id: "overall_target_value",
    //   cell: (info) => info.getValue(),
    //   header: () => <span>Overall Target Value</span>,
    // }),

    columnHelper.accessor((row) => row.goal_title, {
      id: "goal_title",
      cell: (info) => (
        <Link
          to={`/goals/${info.row.original.goal}`}
          state={{ goalId: info.row.original.goal }}
          style={{ textDecoration: "none" }}
        >
          {info.getValue()}
        </Link>
      ),
      header: () => <span>Belongs To</span>,
    }),

    {
      id: "actions",
      cell: (info) => (
        <div>
          <span className='action-item'>
            <FormHandler
              formInputs={{
                formType: "Impact",
                formAction: "Edit",
                itemDetails: {
                  id: info.row.original.id,
                },
              }}
            />
          </span>
          <span className='action-item'>
            <i
              className='bi bi-trash-fill'
              data-bs-placment='center'
              title='Delete'
              onClick={() =>
                deleteDialog(info.row.original.id, info.row.original.title)
              }
            ></i>
          </span>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className='row'>
        <div className='col-12'>
          <h1 style={{ margin: "0" }}>Impacts</h1>
        </div>
        <div className='col-1 mt-2'>
          <Form>
            <Form.Check
              type='radio'
              id='custom-switch'
              label='View all'
              checked={viewAll === "ALL"}
              onChange={() => {
                setviewAll("ALL");
              }}
            />
          </Form>
        </div>
        <div className='col-2 mt-2'>
          <Form>
            <Form.Check
              type='radio'
              id='custom-switch'
              label='View mine'
              checked={viewAll === "MINE"}
              onChange={() => {
                setviewAll("MINE");
              }}
            />
          </Form>
        </div>
        <div className='col text-end pr-5'>
          <FormHandler
            formInputs={{
              formType: "Impact",
              formAction: "Add",
            }}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          {viewAll === "ALL" ? (
            <Table
              defaultData={defaultData}
              columns={columnsAll}
              DELETE_DIALOG_TITLE={DELETE_DIALOG_TITLE}
              DELETE_DIALOG_MESSAGE={DELETE_DIALOG_MESSAGE}
              model={model}
              hideDialog={hideDialog}
              onDelete={deleteHandle}
            />
          ) : (
            <Table
              defaultData={defaultData}
              columns={columnsMine}
              DELETE_DIALOG_TITLE={DELETE_DIALOG_TITLE}
              DELETE_DIALOG_MESSAGE={DELETE_DIALOG_MESSAGE}
              model={model}
              hideDialog={hideDialog}
              onDelete={deleteHandle}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Impacts;
